import * as yup from 'yup';

export interface LoginFormValues {
  email: string;
  password: string;
}

const validationMessages = {
  required: 'This field is required',
  email: 'Enter a valid email address',
};

export const loginValidationSchema = yup.object({
  email: yup
    .string()
    .required(validationMessages.required)
    .min(2, validationMessages.email)
    .email(validationMessages.email)
    .matches(/\.[A-Za-z]{2,}$/, validationMessages.email),
  password: yup.string().required(validationMessages.required),
});
